<!-- 翻页组件 -->
<template>
	<div class="block" style=" width: auto;margin-top: 30px;height: auto;text-align:center;">
		<div style="font-size: 13px;line-height: 30px;margin-right: 10px;display:inline;">
			Page
		</div>
		<div style="margin-right: 15px;display:inline;">
			<el-select v-model="size" placeholder="" size='small' @change="selectPage" style='width: 80px;'>
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			
		</div>
		<div style="display:inline-block;">
			<el-pagination layout="prev, pager, next" background :page-count="pageCunt" :current-page="currentPage" @current-change='currentChange'>
			</el-pagination>
		</div>
		<div style="font-size: 13px;;margin-left: 15px;display:inline;">
			Go
			<input type="text" class="pagenumber" v-model="pagenumber" @keypress="keypage" onkeyup="this.value=this.value.replace(/\D/g,'')" />
			
            <el-button class='btn-go' size='small' @click='setpage'>OK</el-button>
		</div>
		<div style="font-size: 13px;line-height: 30px;margin-left: 30px;display:inline;">
			Total
			<span style="font-weight: bold;font-size: 14px;padding-left: 5px;padding-right: 5px;">{{ total }}</span> 
		</div>
	</div>
</template>

<script>
export default {
    props:{
        total: {//总条数
            required:true,
            type:Number
        } 
    },
    data () {
        return {
            currentPage: 1, //当前页数，当前第几页
            size: 10, //页数下拉框默认值
            options: [ //页数选项
                {
                    label: '10',
                    value: 10
                },
                {
                    label: '20',
                    value: 20
                },
                {
                    label: '30',
                    value: 30
                },
                {
                    label: '40',
                    value: 40
                }
            ],
            row: 10, //每页几条
            pagenumber: 1 //页数输入框的值
        };
    },
    methods:{
        selectPage(val) {
            //改变每页显示条数
            this.row = val;
            this.serch();
        },
        keypage(e) {
            if(e.keyCode === 13) {
                this.setpage();
            }
        },
        setpage() {
            //输入设置当前页
            if(parseInt(this.pagenumber) > this.pageCunt) {
                this.pagenumber = this.pageCunt;
            }
            this.currentPage = parseInt(this.pagenumber);
            this.serch();
        },
        currentChange(val) {
            this.currentPage = val;
            //点击该变当前页
            this.pagenumber = val;
            this.serch();
        },
        serch () {
            this.$emit("serch",this.row,this.currentPage);
        }
    },
    computed:{
        pageCunt () {
            return Math.ceil(this.total / this.row);
        }
    }
};
</script>

<style lang="less" scoped>
	input.pagenumber {
		width: 30px;
		height: 28px;
		border: 1px solid #bfcbd9;
		border-radius: 5px;
		box-sizing: border-box;
		padding-left: 8px;
        outline: none;
        margin-right: 10px;
	}
	.btn-go:hover {
		font-weight: 100 !important;
	}
</style>